/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';

import { useGetImageScale } from 'widgets/team-lineups-v2/js/utils/use-get-image-scale';

import { PlayerPhoto } from 'common/react/components/PlayerPhoto';
import { PlayerProfileLink } from 'widgets/statspro/js/components/common/PlayerProfileLink';

/**
 * Renders a player's name and their photo.
 *
 * @param props
 * @param {object} props.player The player data object.
 * @param {string} props.reason The reason the player is removed, e.g. 'injury'.
 * @param {string} props.matchTitle The match title, e.g. 'Sydney Swans v GWS GIANTS'.
 * @param {boolean} props.isAFLW Is player AFLW (needed to generate correct player profile ulr)
 * @returns {JSX.Element} The player name and photo.
 */
export const InsOutsPlayer = ({
    player,
    reason,
    matchTitle,
    isAFLW = false
}) => {
    const imageScale = useGetImageScale();

    return (
        <div className="team-lineups-ins-and-outs__grid-item-wrapper">
            <PlayerProfileLink
                key={player.playerId}
                classes="team-lineups-ins-and-outs__grid-item"
                player={{
                    playerId: player.playerId,
                    firstName: `${player.playerName.givenName}.`,
                    surname: player.playerName.surname
                }}
                isAFLW={isAFLW}
                trackingInfo={{
                    event: PULSE.app.common.CONSTANTS.TRACKING.EVENTS.SELECT
                        .LINK,
                    component_name: `${matchTitle} (condensed team lineups)`,
                    component_content_type:
                        PULSE.app.common.CONSTANTS.TRACKING.CONTENT_TYPES
                            .LINEUPS
                }}
            >
                <div className="team-lineups-ins-and-outs__player-name-wrapper">
                    <p className="team-lineups-ins-and-outs__player-name">
                        {player.playerName.givenName.charAt(0)}
                        {'. '}
                        {player.playerName.surname}
                    </p>
                    {reason ? (
                        <p className="team-lineups-ins-and-outs__player-reason">
                            {reason}
                        </p>
                    ) : null}
                </div>
                <div className="team-lineups-ins-and-outs__headshot">
                    <PlayerPhoto
                        photoUrl={player?.photoURL}
                        alt={`${player?.playerName?.givenName} ${player?.playerName?.surname}`}
                        scale={imageScale}
                    />
                </div>
            </PlayerProfileLink>
        </div>
    );
};

InsOutsPlayer.propTypes = {
    player: PropTypes.object.isRequired,
    reason: PropTypes.string,
    matchTitle: PropTypes.string.isRequired,
    isAFLW: PropTypes.bool
};
